module.exports = __webpack_public_path__ + "static/media/Hand-grey.b60f3765.png";